import { Injectable } from '@angular/core';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { LoansStatus } from 'src/shared/enum';
import { AppSummary, MembershipDetails, PostApplicationBanner, PostApplicationTask } from '../models/application.model';
import { ApplicationData } from '../consts/application-data.const';
import { Observable } from 'rxjs';
import { StatefulService } from '@app/service/stateful.service';

/**
 * Service representing consumer loan service section
 * @Service
 */
@Injectable({
  providedIn: 'root'
})
export class AccountApplicationService {
  constructor(private readonly apiService: ApiService, private readonly statefulService: StatefulService) {}

  /**
   * Function for get the app summary
   */
  public getAppSummary(appNumber: string): Observable<AppSummary> {
    // if (!appNumber) return Observable.reject(null);
    return this.apiService.request<AppSummary>({
      body: JSON.stringify(appNumber),
      urlObj: ApplicationData.GetAppSummary
    });
  }

  /**
   * Get Overview Banner data for OAO
   * @param appId string
   * @returns AppSummary
   */
  public GetOAOOverviewBannerData(appId: string): Observable<PostApplicationBanner> {
    return this.apiService.request<PostApplicationBanner>({
      body: JSON.stringify(appId),
      urlObj: ApplicationData.GetOAOOverviewBanner
    });
  }

  /**
   * Function for get the app summary
   */
  public getOAOPostAppTasks(appNumber: string): Observable<PostApplicationTask> {
    return this.apiService.request<PostApplicationTask>({
      body: JSON.stringify(appNumber),
      urlObj: ApplicationData.GetOAOPostAppTasks
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getOAOSubmissionStatus(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.request<any>({ urlObj: ApplicationData.GetOAOSubmissionStatus as any });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getOLASubmissionStatus(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.request<any>({ urlObj: ApplicationData.GetOLASubmissionStatus as any });
  }

  /**
   * Function for get the app cross sell
   */
  public getCrossSellAppSummary(appNumber: string, callback: (response: AppSummary) => void, errorCallback: (err) => void): void {
    if (!appNumber) return;
    const urlObj = { ...ApplicationData.GetAppSummary };
    this.apiService.requestApi({
      callback,
      errorCallback,
      urlObj,
      body: JSON.stringify(appNumber)
    });
  }

  /**
   * Function for get the membership details
   */
  public getMembershipDetails(appNumber, callback: (response: MembershipDetails) => void, errorCallback: (err) => void): void {
    this.apiService.requestApi({
      callback,
      errorCallback,
      body: JSON.stringify(appNumber),
      urlObj: ApplicationData.GetAppDetails
    });
  }

  // /**
  //  * Function for approved loan status
  //  */
  public isApprovedLoan(loanStatus: string): boolean {
    // check if loan is approved, pre-approved or conditionally approved
    if (loanStatus.toLowerCase() === LoansStatus.Approved || loanStatus.toLowerCase() === LoansStatus.Counter) {
      return true;
    }
    return false;
  }

  public appSubmitListener(path: string, value: string, cb: (res: boolean) => void): void {
    const state = this.statefulService.wrap(path);
    const maxTime = new Date(new Date().getTime() + 2 * 60000);
    const loadFn = () => {
      if (state && state.valueString && state.valueString.toLowerCase() === value) {
        cb(true);
      } else if (new Date() < maxTime) {
        setTimeout(() => {
          state.load(loadFn);
        }, 3000);
      } else {
        cb(false);
      }
    };
    state.load(loadFn);
  }

  public loanSubmitListener(path: string, value: boolean, cb: (res: boolean) => void): void {
    const state = this.statefulService.wrap(path);
    const maxTime = new Date(new Date().getTime() + 3 * 60000);
    const loadFn = () => {
      if (state.value === value) {
        cb(true);
      } else if (new Date() < maxTime) {
        setTimeout(() => {
          state.load(loadFn);
        }, 3000);
      } else {
        cb(false);
      }
    };
    state.load(loadFn);
  }
}
